import axios from 'axios';

export const getAllTaxes = () => axios.get('v1/pricing/taxes');